// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a244bdbd","845":"ff340d66"}[chunkId] + ".chunk.js";
};